import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function OBGYNMenopausePage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d62j4380h9ov63emh8dg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
      }
    } catch (error) {
      setFormStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#F5F3FF] via-white to-[#FAF5FF] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-xl">
              <div className="inline-block px-4 py-2 bg-[#7C3AED]/10 rounded-full text-[#7C3AED] text-sm font-medium mb-6">
                OB-GYNs & Menopause Specialists
              </div>
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Attract More Patients Seeking Women's Health & Menopause Care
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                HIPAA-compliant digital marketing and automated patient acquisition for OB-GYNs, menopause specialists, and women's health providers who want to grow their practice with qualified patients.
              </p>
              <div className="flex flex-wrap gap-4">
                <a href="#contact-form" className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#7C3AED] to-[#A855F7] text-white rounded-lg font-semibold hover:shadow-lg transition-all whitespace-nowrap">
                  Book Free Strategy Call
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <Link to="/services/marketing-automation" className="inline-flex items-center px-8 py-4 bg-white text-[#7C3AED] rounded-lg font-semibold hover:bg-[#7C3AED]/5 transition-all border-2 border-[#7C3AED] whitespace-nowrap">
                  See Our Automation Platform
                </Link>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/53eaf7e501c71af9beddc0c5edc07e65.jpg"
                alt="OB-GYN Practice"
                className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Challenges Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Common Growth Challenges for OB-GYN & Menopause Practices
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We understand the unique marketing obstacles women's health providers face
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-search-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Low Online Visibility</h3>
              <p className="text-gray-600">
                Patients searching for menopause treatment, hormone therapy, or women's wellness can't find your practice online.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-phone-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Missed Lead Follow-ups</h3>
              <p className="text-gray-600">
                Busy clinical schedules mean inquiries fall through the cracks, and potential patients choose competitors.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-user-search-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Unqualified Inquiries</h3>
              <p className="text-gray-600">
                Your team wastes time on leads who aren't ready, can't afford care, or aren't a good fit for your services.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-cross-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">HIPAA Compliance Concerns</h3>
              <p className="text-gray-600">
                Worried about patient data security and compliance when using marketing tools and platforms.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-star-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Limited Online Reviews</h3>
              <p className="text-gray-600">
                Few patient reviews make it harder to build trust and stand out from other women's health providers.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-line-chart-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Inconsistent Patient Flow</h3>
              <p className="text-gray-600">
                Unpredictable new patient volume makes it difficult to plan staffing and grow your practice sustainably.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our HIPAA-Compliant Marketing Solutions
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Proven strategies designed specifically for OB-GYN and menopause practices
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20female%20doctor%20consulting%20with%20middle%20aged%20woman%20patient%20about%20menopause%20treatment%20in%20modern%20medical%20office%2C%20warm%20lighting%2C%20healthcare%20consultation%2C%20compassionate%20care%2C%20medical%20expertise%2C%20womens%20health%20specialist&width=600&height=400&seq=obgyn1&orientation=landscape"
                alt="OB-GYN consultation"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Automated Patient Acquisition System
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Our marketing automation platform ensures every inquiry is captured, nurtured, and converted—even when you're with patients.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">Instant Lead Response:</strong> Automated follow-up within minutes of inquiry</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">Smart Nurture Sequences:</strong> Educational content about menopause, HRT, and women's wellness</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">Appointment Booking:</strong> Automated scheduling that fills your calendar</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">HIPAA-Conscious:</strong> Secure systems designed for healthcare compliance</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-violet-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Comprehensive Marketing Services for Your Practice
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Everything you need to attract, convert, and retain more patients
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Link to="/services/medical-seo" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-search-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Medical SEO</h3>
              <p className="text-gray-600 mb-4">
                Rank #1 for "menopause specialist near me," "hormone therapy," and "OB-GYN" searches in your area.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/healthcare-ppc" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-advertisement-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Google & Meta Ads</h3>
              <p className="text-gray-600 mb-4">
                HIPAA-compliant paid advertising that brings qualified patients actively seeking women's health care.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/medical-website-design" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-layout-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Website Design</h3>
              <p className="text-gray-600 mb-4">
                Beautiful, conversion-optimized websites that educate patients and drive appointment bookings.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/reputation-management" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Reputation Management</h3>
              <p className="text-gray-600 mb-4">
                Build trust with more 5-star reviews from satisfied patients across Google and healthcare directories.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/content-marketing" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-article-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Content Marketing</h3>
              <p className="text-gray-600 mb-4">
                Educational content about menopause, HRT, and women's wellness that establishes your authority.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/marketing-automation" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-robot-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Marketing Automation</h3>
              <p className="text-gray-600 mb-4">
                Never miss a lead with automated nurturing, follow-up, and patient engagement systems.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Trusted by Leading Women's Health Providers
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-purple-50 to-violet-50 p-8 rounded-xl border border-purple-100">
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20female%20doctor%20headshot%20portrait%2C%20confident%20medical%20professional%2C%20womens%20health%20specialist%2C%20warm%20smile%2C%20medical%20expertise&width=80&height=80&seq=obgyntest1&orientation=squarish"
                  alt="Dr. Sarah Mitchell"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold text-gray-900">Dr. Sarah Mitchell</div>
                  <div className="text-sm text-gray-600">OB-GYN, Women's Wellness Center</div>
                </div>
              </div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed">
                "MillionDollarMed transformed our patient acquisition. Their automation platform ensures we never miss an inquiry, and our new patient volume has increased by 180% in 6 months. The HIPAA-compliant systems give us complete peace of mind."
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-violet-50 p-8 rounded-xl border border-purple-100">
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20female%20physician%20headshot%20portrait%2C%20experienced%20menopause%20specialist%2C%20confident%20healthcare%20provider%2C%20professional%20medical%20attire&width=80&height=80&seq=obgyntest2&orientation=squarish"
                  alt="Dr. Jennifer Rodriguez"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold text-gray-900">Dr. Jennifer Rodriguez</div>
                  <div className="text-sm text-gray-600">Menopause & Hormone Specialist</div>
                </div>
              </div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed">
                "Finally, a marketing partner who understands women's health. Their SEO strategy has us ranking #1 for menopause treatment in our city, and the automated follow-up system converts leads while I'm seeing patients. Highly recommend!"
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact-form" className="py-20 bg-gray-50">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Book Your Free Strategy Call
            </h2>
            <p className="text-xl text-gray-600">
              Let's discuss how we can help grow your OB-GYN or menopause practice with HIPAA-compliant marketing and automation.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="bg-white p-8 md:p-12 rounded-2xl shadow-lg" data-readdy-form id="obgyn-strategy-form">
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="Dr. Jane Smith"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="doctor@practice.com"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="(555) 123-4567"
                />
              </div>
              <div>
                <label htmlFor="practice" className="block text-sm font-semibold text-gray-700 mb-2">
                  Practice Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="practice"
                  name="practice"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="Your Practice Name"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="specialty" className="block text-sm font-semibold text-gray-700 mb-2">
                Specialty Focus <span className="text-red-500">*</span>
              </label>
              <select
                id="specialty"
                name="specialty"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
              >
                <option value="">Select your specialty</option>
                <option value="obgyn">OB-GYN</option>
                <option value="menopause">Menopause Specialist</option>
                <option value="womens-health">Women's Health</option>
                <option value="hormone-therapy">Hormone Therapy</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="mb-6">
              <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                What are your biggest marketing challenges? <span className="text-red-500">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm resize-none"
                placeholder="Tell us about your practice goals and challenges..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
            </div>

            <div className="mb-6">
              <label className="flex items-start">
                <input
                  type="checkbox"
                  name="consent"
                  required
                  className="mt-1 mr-3"
                />
                <span className="text-sm text-gray-600">
                  I agree to receive communications from MillionDollarMed. All information is handled in accordance with HIPAA guidelines and our privacy policy.
                </span>
              </label>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-purple-600 to-violet-600 text-white py-4 rounded-lg font-semibold hover:from-purple-700 hover:to-violet-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Book My Free Strategy Call
            </button>

            {formStatus === 'success' && (
              <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-800 text-center font-semibold">
                  Thank you! We'll contact you within 24 hours to schedule your strategy call.
                </p>
              </div>
            )}

            {formStatus === 'error' && (
              <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-800 text-center font-semibold">
                  Something went wrong. Please try again or call us directly.
                </p>
              </div>
            )}
          </form>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-[#0D9488] to-[#14B8A6]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Grow Your Women's Health Practice?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Join leading OB-GYNs and menopause specialists who trust MillionDollarMed for HIPAA-compliant marketing and automated patient acquisition.
          </p>
          <a href="#contact-form" className="inline-flex items-center px-8 py-4 bg-white text-[#0D9488] rounded-lg font-semibold hover:bg-gray-50 transition-all text-lg whitespace-nowrap">
            Schedule Your Free Consultation
            <i className="ri-calendar-line ml-2"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
